import React, { useState, useEffect } from "react";

import { useSelector } from "react-redux";
import './styles.scss'
import {
    AppLayout,
    Box,
} from "@amzn/awsui-components-react";
import SideNav from "./SideNav";

import FirstPassHistoryComponent from "./Components/FirstPassHistoryComponent";
export default (props) => {
    const [NavOpen, setNavOpen] = useState(false);
    const [customSideNavitems, setCustomSideNavitems] = useState([
        {
            "type": "link",
            "text": "About",
            "href": `/firstpass`
        },

        { "type": "divider" },

        {
            "type": "link",
            "text": "Back",
            "href": "/"
        },
    ])
    const userId = useSelector((globalState) => globalState.auth.userId);
    const currentStage = useSelector((globalState) => globalState.auth.currentStage)

    useEffect(() => {
    }, [userId, currentStage])

    const Content = (
        <Box margin="l">
            <FirstPassHistoryComponent></FirstPassHistoryComponent>
        </Box>
    )

    return (
        <AppLayout
            disableContentPaddings={true}
            navigation={<SideNav activeHref={`/firstpass`} customSideNavitems={customSideNavitems} />}
            navigationOpen={NavOpen}
            content={Content}
            headerSelector="#TopBar"
            toolsHide={true}
            navigationHide={true}
            onNavigationChange={() => {
                setNavOpen(!NavOpen);
            }}
            headerVariant="high-contrast"
        />

    );
}
